import React, { useLayoutEffect, useEffect, useState } from 'react';
import axios from 'axios';
import styles from '../styles/pages/aboutuspage.module.css';
import { GradientCardNoIcon } from '../components/GradientCard';
import { FaClock } from "react-icons/fa6";
import ModalBranch from '../components/ModalBranch'; // Assuming it's in this path
import { useAuth } from "../authentication/AuthContext";
function BranchesTimings() {
  const [branches, setBranches] = useState([]);
  const timings = "10.30 am - 5.30 pm";
  const lunch_timings = "2.30 pm - 3.30 pm";
const { isAuthenticated } = useAuth();
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    fetchBranches();
  }, []);

  const fetchBranches = async () => {
    try {
      const res = await axios.get('/api/branchTiming');
      setBranches(res.data.data);
    } catch (err) {
      console.error('Error fetching branches:', err);
    }
  };

  const handleBranchSubmit = async (updatedBranches) => {
    try {
      for (const branch of updatedBranches) {
        await axios.post('/api/branchTiming', branch); // upsert logic
      }
      fetchBranches(); // refresh
    } catch (err) {
      console.error('Error updating branches:', err);
    }
  };

  return (
    <div className='body'>
      <div className='heading'>BRANCHES</div>
      <hr />
      <hr />

      {/* 🔧 Modal to edit/add branches */}
      {isAuthenticated  && (  
      <ModalBranch value={branches} onSubmit={handleBranchSubmit} />
    )} 
      <div className={styles.branches}>
        {branches.map((item, index) => (
          <GradientCardNoIcon
            key={index}
            title={item.branchName}
            title1="Address :"
            desc1={item.address}
            title2="Branch Manager :"
            desc2={item.branchManager}
            latitude={item.latitude}
            longitude={item.longitude}
          />
        ))}
      </div>

      <div className='break' />
      <div className='break' />

      <div className='heading'>BANK TIMINGS</div>
      <hr />
      <hr />
      <div className={styles.timings}>
        <div className={styles.highlight}>
          <FaClock /> {timings}
          <p>Lunch Timings : {lunch_timings}</p>
          <p>Holidays : 2nd/4th Saturday and Sundays</p>
        </div>
      </div>
    </div>
  );
}

export default BranchesTimings;
